import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'ef-discount-banner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<div
    class="md:w-full md:h-full md:rounded-lg min-h-[600px] bg-[url(assets/empikfoto/images/discount_banner_background.webp)] bg-cover bg-center flex flex-col justify-between"
  >
    <div class="flex flex-col gap-4 bg-purple-1 text-white p-4 md:p-6 md:rounded-t-lg"
      ><p i18n class="text-heading-05-normal md:text-heading-04-normal"
        >Zapisz się do newslettera i otrzymaj jednorazową zniżkę na wszystko</p
      ><p i18n class="text-[3.5rem]/[3.5rem] font-bold md:text-[4.5rem]">-15%</p></div
    >
    <div class="p-4 md:p-6 text-body-03">
      <p i18n class="text-center"
        >Zapisz się do newslettera podczas zakładania konta,<br />a <b>kod rabatowy</b> otrzymasz na maila w ciągu kilku
        minut.</p
      >
    </div>
  </div> `,
})
export class EfDiscountBannerComponent {}
